import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    overflow-y: scroll;
    height: calc(100vh - 64px);
`

export const PokeList = styled.ul`
    padding: 0;
    list-style-type: none;
    margin-top: 15px;
`
export const PokeItem = styled.li`
    list-style-type: none;
`

export const ItemCard = styled.div`
    background-color: ${props => props.capturado == "true" ? props.color : "rgb(180, 186, 196)"};
    border-radius: 20px;
    width: 90vw;
    height: 15vh;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    box-shadow: 0px -1px 18px -6px rgba(0,0,0,0.49);
    margin-top: 10px;
`

export const PokeImg = styled.img`
    position: absolute;
    right: 0;
    width: 30%;
    filter: ${props => props.capturado == "false" && "contrast(0%) brightness(50%)" };
`
export const BallImg = styled.img`
    position: absolute;
    right: 0;
    width: 25%;
    filter: invert(100%) opacity(30%);
    transform: scale(140%) translateX(-10%);
`

export const ItemData = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    margin-left: 5%;
    margin-bottom: 10%;
`
export const PokeTipo = styled.img`
    transform: scale(.8) translate(-10%, 10%);
    position: absolute;
    left: 0;
    bottom: 0;
`

export const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`